export default {
    uploadPicture: '/api/basic/users/uploadPicture', // 上传用户头像
    setPassword: '/basic/users/setPassword', // 修改密码
    // getUserInfo:'/usernfo/auth/getUserInfo', // 获取用户信息
    getImage: '/basic/users/getImage', // 获取用户头像
    getUserInfo: '/basic/users/query', // 获取用户信息
    setUserInfo: '/basic/users/update' //修改用户信息
};
